export function getCleanedSettings(settings = {}) {
    for(let name in settings) {
        if(name[0] === "_" && name[1] === "_") {
            delete settings[name]
        }
    }
    return settings
}